// Which animation-result url a single-image "Canlandır" (animate) accept
// should apply. Owner directive: animations are looping WebP applied in
// place (same box, only the url changes) — never an automatic box-swap to a
// playable MP4. So image-format outputs (webp, then gif) always win; mp4 is
// picked only when neither exists (legacy jobs recorded before the webp
// default, whose only output is an mp4).
export function pickAnimationApplyUrl({ webpUrl, gifUrl, mp4Url, fallbackUrl } = {}) {
  return webpUrl || gifUrl || fallbackUrl || mp4Url || null;
}
